module.exports = __webpack_public_path__ + "img/u6324.09a61218.png";